import apiClient from './apiClient';

/**
 * API service for fetching client-side configuration.
 */
export const configApi = {
  /**
   * Get Google Maps API key from the backend.
   * The key is stored in Azure Key Vault and served via the API.
   */
  getGoogleMapsApiKey: async (): Promise<string | null> => {
    try {
      const response = await apiClient.get<{ apiKey: string }>('/config/google-maps-key');
      return response.data?.apiKey ?? null;
    } catch (error) {
      console.warn('Failed to fetch Google Maps API key:', error);
      return null;
    }
  },
};
